<div class="mat-typography mat-app-background">

    <div class="d-flex justify-content-between">
        <div>
            <h2 mat-dialog-title class="d-flex align-items-center w-100 mb-0 pb-0">
                <!-- 1) Title on the left -->
                <span>{{ dialogTitle }}</span>

                <!-- 2) Center spacer that only contains the spinner, and centers it -->
                <div class="flex-fill d-flex justify-content-center">
                    <img *ngIf="spinner1" src="app/assets/images/waiting4Response.gif" width="22" height="22"
                        class="align-self-start">
                </div>
            </h2>
        </div>
        <div>
            <mat-form-field *ngIf="refSrch" style="width: 280px; margin-top: 10px; margin-right: 10px;">
                <mat-label style="font-style: italic;"><span class="font12">{{engLang ? 'Last[,] first name or
                        NPI to
                        search...' : 'Apellidos[,]
                        nombre o NPI para
                        buscar... '}}</span>
                    <span style="font-style: normal;">(ENTER)</span>
                    <span *ngIf="spinner2">
                        <img src="app/assets/images/waiting4Response.gif" width="22" height="22" class="text-center">
                    </span>
                </mat-label>

                <input matInput [formControl]="searchRefCtrl" [matAutocomplete]="refAuto" id="searchRefInput"
                    appUppercase (keyup.enter)="onEnter_searchRefCtrl(searchRefCtrl.value)">
                <mat-autocomplete #refAuto="matAutocomplete" (optionSelected)="onClick_select($event.option.value)">
                    <!-- (optionSelected)="onChange_searchRefCtrl($event.option.value)" -->
                    <mat-option *ngFor="let opt of filteredRefs" [value]="opt.pKey">
                        {{opt.alias}}<span style="font-size: 8px;">{{ data.lstTyp === 'ref' ? ' ' + opt.npi : '
                            (' +
                            opt.pKey + ')' }}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <mat-error *ngIf="searchRefCtrl.errors?.['pattern']" class="margin-top-20">
                <span class="error-text">
                    {{ engLang ? 'Letters to search names or digits for NPI' : 'Letras para buscar nombre o dígitos para
                    NPI' }}
                </span>
            </mat-error>
        </div>
        <div>
            <!-- 3) (Optional) Right slot for a close-button or whatever -->
            <button mat-icon-button (click)="onClick_close($event)">
                <mat-icon class="font15 pointr">close</mat-icon>
            </button>
        </div>
    </div>

    <div [formGroup]="form">

        <div class="text-center">
            <mat-toolbar style="height: 40px; min-height: 40px;">
                <div class="d-flex justify-content-end w-100">
                    <div>
                        <button mat-button (click)="onClick_add()">
                            <mat-icon class="mx-1">person_add</mat-icon>
                            <span class="font12 pointr">{{engLang ? 'Add':'Añadir'}}</span>
                        </button>
                    </div>
                    <div>
                        <button mat-button (click)="onClick_delete($event)">
                            <mat-icon class="mx-1">delete</mat-icon>
                            <span class="font12 pointr">{{engLang ? 'Delete':'Eliminar'}}</span>
                        </button>
                    </div>
                    <div *ngIf="data.lstTyp === 'ref'">
                        <button mat-button (click)="onClick_showRefSearch($event)">
                            <mat-icon class="mx-1">search</mat-icon>
                            <span class="font12 pointr">{{engLang ? 'Find':'Buscar'}}</span>
                        </button>
                    </div>
                    <div *ngIf="data.lstTyp === 'prov'">
                        <button mat-button>
                            <mat-icon class="mx-1">alt_route</mat-icon>
                            <span class="font12 pointr">{{engLang ? 'Alt Conf':'Conf Alt'}}</span>
                        </button>
                    </div>
                    <div>
                        <button mat-button [disabled]="!form.valid" (click)="onClick_save($event)">
                            <mat-icon class="mx-1">save</mat-icon>
                            <span class="font12 pointr">{{engLang ? 'Save':'Grabar'}}</span>
                        </button>
                    </div>
                </div>
            </mat-toolbar>

            <mat-form-field style="height: 75px; min-height: 75px; width: 100%;">
                <mat-label>{{engLang ? 'Alias (internal name)' : 'Alias (nombre interno)'}}</mat-label>
                <mat-select class="font15 pointr" (selectionChange)="onChange_item($event.value)" formControlName="pKey"
                    cdkFocusInitial>

                    <mat-option *ngFor="let item of items" [value]="item.pKey">
                        {{item.alias}}<span style="font-size: 8px;">{{ data.lstTyp === 'ref' ? ' (' + item.npi + ')' : '
                            (' +
                            item.pKey + ')' }}</span>
                    </mat-option>

                </mat-select>
            </mat-form-field>
        </div>

        <mat-dialog-content class="pt-1" style="margin-top: 0">
            <div class="d-flex justify-content-between" *ngIf="data.lstTyp !== 'ref'">
                <div class="label-div">
                    <mat-label>Alias:</mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="Alias" formControlName="alias" appUppercase maxlength="35"
                            #aliasHint>
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{aliasHint.value.length}} / 35
                        </mat-hint>
                    </mat-form-field>
                    <mat-error *ngIf="alias.invalid && alias.touched" class="margin-top-20">
                        <span *ngIf="alias.errors?.required" class="font12">
                            {{engLang ? 'Required': 'Requisito'}}
                        </span>
                        <span *ngIf="alias.errors?.['pattern']" class="font12">
                            {{engLang ? 'Invalid character': 'Caracter inválido'}}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between">
                <div class="d-flex">
                    <div>
                        <mat-label>{{engLang ? 'Inactive': 'Inactivo'}}:</mat-label>
                    </div>
                    <div [popper]="popperInactive" [popperShowOnStart]="false" [popperTrigger]="'click'"
                        [popperHideOnClickOutside]="true" [popperHideOnScroll]="true" [popperPlacement]="'top'"
                        [popperPositionFixed]="true">&nbsp;
                        <i class="fas fa-question-circle" (click)="onClick_showPopperInactive($event)"
                            style="cursor: pointer"></i>
                        <popper-content #popperInactive>
                            <div class="popper-content">
                                {{engLang ? 'You cannot create claims with an inactive provider as it will not appear in
                                the
                                providers list.': 'No se puede crear facturación con un proveedor inactivo porque no se
                                muestra
                                en la lista de proveedores.'}}
                            </div>
                        </popper-content>
                    </div>
                </div>

                <div class="text-start">
                    <mat-checkbox formControlName="inactive"></mat-checkbox>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp !== 'plan'">
                <div class="label-div">
                    <mat-label>NPI:</mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="NPI" formControlName="npi" appUppercase #npiHint maxlength="10">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{npiHint.value.length}} / 10
                        </mat-hint>
                    </mat-form-field>
                    <mat-error *ngIf="npi?.errors?.['npiCkDigit'] && npi?.touched" class="margin-top-20">
                        <span class="error-text">
                            {{ engLang
                            ? npi?.errors?.['npiCkDigit'].messageEn
                            : npi?.errors?.['npiCkDigit'].messageEs }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'plan'">
                <div class="label-div">
                    <mat-label>Payer ID:</mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="Payer ID" formControlName="payerID" #payerIDHint maxlength="20">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{payerIDHint.value.length}} / 20
                        </mat-hint>
                    </mat-form-field>
                    <mat-error *ngIf="payerID?.errors?.required && payerID?.touched" class="margin-top-20">
                        <span class="error-text">
                            {{ engLang
                            ? 'Required'
                            : 'Requisito' }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'plan'">
                <div class="label-div">
                    <mat-label>Payer ID (835):</mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="Payer ID (835)" formControlName="payerID_835" #payerID_835Hint
                            maxlength="20">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{payerID_835Hint.value.length}} / 20
                        </mat-hint>
                    </mat-form-field>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'prov'">
                <div class="label-div">
                    <mat-label>{{engLang ? 'Last name:' : 'Apellidos:'}}<span *ngIf="data.lstTyp === 'prov'">{{engLang ?
                            ' (if a person)' : ' (si una persona)'}}</span></mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="{{engLang ? 'Last name':'Apellidos'}}" formControlName="last"
                            appUppercase #lastHint maxlength="20">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{lastHint.value.length}} / 20
                        </mat-hint>
                    </mat-form-field>
                    <mat-error *ngIf="last.invalid && last.touched" class="margin-top-20">
                        <span class="error-text" *ngIf="last.errors?.['pattern']">
                            {{ engLang ? 'Invalid character' : 'Caracter inválido' }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'prod' || data.lstTyp === 'ref'">
                <div class="label-div">
                    <mat-label>{{engLang ? 'Last name:' : 'Apellidos:'}}</mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="{{engLang ? 'Last name':'Apellidos'}}" formControlName="lastReq"
                            appUppercase #lastHintReq maxlength="20">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{lastHintReq.value.length}} / 20
                        </mat-hint>
                    </mat-form-field>
                    <mat-error *ngIf="lastReq.invalid && lastReq.touched" class="margin-top-20">
                        <span class="error-text" *ngIf="lastReq.errors?.required">
                            {{ engLang ? 'Required, invalid' : 'Requisito' }}
                        </span>
                        <span class="error-text" *ngIf="lastReq.errors?.['pattern']">
                            {{ engLang ? 'Invalid character' : 'Caracter inválido' }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'prov'">
                <div class="label-div">
                    <mat-label>{{engLang ? 'First name:' : 'Nombre:'}}<span *ngIf="data.lstTyp === 'prov'">{{engLang ? '
                            (if a person)' : ' (si una persona)'}}</span></mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="{{engLang ? 'First name':'Nombre'}}" formControlName="first"
                            appUppercase #firstHint maxlength="20">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{firstHint.value.length}} / 20
                        </mat-hint>
                    </mat-form-field>
                    <mat-error *ngIf="first.invalid && first.touched" class="margin-top-20">
                        <span class="error-text" *ngIf="first.errors?.['pattern']">
                            {{ engLang ? 'Invalid character' : 'Caracter inválido' }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'prod' || data.lstTyp === 'ref'">
                <div class="label-div">
                    <mat-label>{{engLang ? 'First name:' : 'Nombre:'}}</mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="{{engLang ? 'First name':'Nombre'}}" formControlName="firstReq"
                            appUppercase #firstHintReq maxlength="20">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{firstHintReq.value.length}} / 20
                        </mat-hint>
                    </mat-form-field>
                    <mat-error *ngIf="firstReq.invalid && firstReq.touched" class="margin-top-20">
                        <span class="error-text" *ngIf="firstReq.errors?.required">
                            {{ engLang ? 'Required, invalid' : 'Requisito' }}
                        </span>
                        <span class="error-text" *ngIf="firstReq.errors?.['pattern']">
                            {{ engLang ? 'Invalid character' : 'Caracter inválido' }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between"
                *ngIf="data.lstTyp === 'prov' || data.lstTyp === 'fac' || data.lstTyp === 'plan'">
                <div class="label-div">
                    <mat-label>
                        <span *ngIf="data.lstTyp === 'prov'">
                            {{ (engLang ? 'Group/Corp.':'Grupo/Corp.') }}
                        </span>
                        <span *ngIf="data.lstTyp === 'plan'">
                            {{ (engLang ? 'Insurance Name':'Nombre Aseguradora') }}
                        </span>
                        <span *ngIf="data.lstTyp == 'fac'">
                            {{ (engLang ? 'Name':'Nombre') }}
                        </span>
                    </mat-label>
                </div>
                <div class="d-flex flex-column align-items-end">
                    <div>
                        <mat-form-field>
                            <input matInput
                                placeholder="{{ data.lstTyp === 'fac' ? (engLang ? 'Facility name':'Nombre facilidad') : (data.lstTyp !== 'plan' ? (engLang ? 'Group/Corp.':'Grupo/Corp.') : (engLang ? 'Insurance Name':'Nombre Aseguradora')) }}"
                                formControlName="group" formControlName="corp" appUppercase #corpHint maxlength="40">
                            <mat-hint class="font9 margin-top-5" align="end">
                                {{corpHint.value.length}} / 40
                            </mat-hint>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-error *ngIf="corp.touched" class="margin-top-20 pt-1">
                            <p *ngIf="form.errors?.personVsGroup && data.lstTyp === 'prov'"
                                class="error-text align-self-end" style="float:inline-end; text-align: center;">
                                {{engLang ? 'Last/First names incompatible with Group/Corp': 'Apellidos/Nombre
                                incompatibles
                                con Grupo/Corp'}}
                            </p>
                            <p *ngIf="corp.errors?.['pattern'] && !form.errors?.personVsGroup" class="font12"
                                style="float:inline-start; text-align: start;">
                                {{ engLang ? 'Invalid character' : 'Caracter inválido' }}
                            </p>
                            <span *ngIf="corp.errors?.required" class="font12">
                                {{ engLang ? 'Required': 'Requisito' }}
                            </span>
                        </mat-error>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'prov' || data.lstTyp === 'fac'">
                <div class="label-div d-flex">
                    <div>
                        <mat-label>{{engLang ? 'Address 1 (physical):' : 'Dirección 1 (física):'}}</mat-label>
                    </div>
                    <div [popper]="popperPhyAdr" [popperShowOnStart]="false" [popperTrigger]="'click'"
                        [popperHideOnClickOutside]="true" [popperHideOnScroll]="true" [popperPlacement]="'top'"
                        [popperPositionFixed]="true">&nbsp;
                        <i class="fas fa-question-circle" style="cursor: pointer"></i>
                    </div>
                </div>
                <popper-content #popperPhyAdr>
                    <div class="popper-content">
                        {{engLang ? 'Required in segment NM1*85 files 837 & slot 33 form CMS-1500. No postal address
                        allowed.': 'Se requiere en el segmento NM1*85 en archivos 837 y encasillado 33 forma CMS-1500.
                        No puede ser dirección postal.'}}
                    </div>
                </popper-content>

                <div>
                    <mat-form-field>
                        <input matInput placeholder="{{engLang ? 'Address 1':'Dirección 1'}}" formControlName="phyAd1"
                            appUppercase #phyAd1Hint maxlength="30">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{phyAd1Hint.value.length}} / 30
                        </mat-hint>
                    </mat-form-field>
                    <mat-error *ngIf="phyAd1.invalid && phyAd1.touched" class="margin-top-20">
                        <span class="error-text" *ngIf="phyAd1.errors?.['pattern'] || phyAd1.errors?.required">
                            {{ engLang ? 'Required, invalid' : 'Requerida, inválida' }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'prov' || data.lstTyp === 'fac'">
                <div class="label-div">
                    <mat-label>{{engLang ? 'Address 2 (physical):' : 'Dirección 2 (física):'}}</mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="{{engLang ? 'Address 2':'Dirección 2'}}" formControlName="phyAd2"
                            appUppercase #phyAd2Hint maxlength="30">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{phyAd2Hint.value.length}} / 30
                        </mat-hint>
                    </mat-form-field>
                    <mat-error *ngIf="phyAd2.invalid && phyAd2.touched" class="margin-top-20">
                        <span class="error-text" *ngIf="phyAd2.errors?.['pattern']">
                            {{ engLang ? 'Invalid' : 'Inválida' }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'prov' || data.lstTyp === 'fac'">
                <div class="label-div">
                    <mat-label>{{engLang ? 'Zip code (physical):' : 'Código zip (física):'}}</mat-label>
                </div>
                <div>
                    <mat-form-field class="select-width">
                        <input type="text" matInput [formControl]="zipControlPhy" [matAutocomplete]="zipAutoPhy"
                            placeholder="Zip Code" (keyup.enter)="onSelectZipPhy($event.target.value)" #zipPhyHint
                            maxlength="10">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{zipPhyHint.value.length}} / 9
                        </mat-hint>
                        <!-- Autocomplete Dropdown -->
                        <mat-autocomplete #zipAutoPhy="matAutocomplete"
                            (optionSelected)="onSelectZipPhy($event.option.value)">
                            <mat-option *ngFor="let zip of filteredZipsPhy | async" [value]="zip.zipCode">
                                {{ zip.zipCode }} <span style="font-size: 8px;">{{ zip.zipCity + ', ' + zip.zipState
                                    }}</span>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-error *ngIf="zipControlPhy.invalid && zipControlPhy.touched" class="margin-top-20">
                        <span class="error-text">
                            {{ engLang ? '9 digits required' : '9 dígitos requisito' }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'prov' || data.lstTyp === 'fac'">
                <div class="label-div">
                    <mat-label>{{engLang ? 'City:' : 'Ciudad:'}}</mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="{{engLang ? 'City':'Ciudad'}}" formControlName="phyCity"
                            appUppercase #phyCityHint maxlength="20">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{phyCityHint.value.length}} / 20
                        </mat-hint>
                    </mat-form-field>
                    <mat-error *ngIf="phyCity.invalid && phyCity.touched" class="margin-top-20">
                        <span class="error-text">
                            {{ engLang ? 'Invalid required' : 'Inválida requisito' }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'prov' || data.lstTyp === 'fac'">
                <div class="label-div">
                    <mat-label>{{engLang ? 'State:' : 'Estado:'}}</mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="{{engLang ? 'State':'Estado'}}" formControlName="phySt" #phyStHint
                            maxlength="2" appUppercase>
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{phyStHint.value.length}} / 2
                        </mat-hint>
                    </mat-form-field>
                    <mat-error *ngIf="phySt.invalid && phySt.touched" class="margin-top-20">
                        <span class="error-text">
                            {{ engLang
                            ? phySt?.errors['ckState']?.messageEn
                            : phySt?.errors['ckState']?.messageEs }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'prov' || data.lstTyp === 'prod'">
                <div class="label-div">
                    <mat-label>{{engLang ? 'Taxonomy code:' : 'Código Taxonomy:'}}</mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="Taxonomy" formControlName="taxo" appUppercase>
                    </mat-form-field>
                    <mat-error *ngIf="taxo.invalid && taxo.touched" class="margin-top-20">
                        <span class="error-text" *ngIf="taxo.errors?.required">
                            {{engLang ? 'Required': 'Requisito'}}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'prov'">
                <div class="label-div d-flex">
                    <mat-label>{{engLang ? 'Address 1 (postal):' : 'Dirección 1 (postal):'}}</mat-label>
                    <div [popper]="popperPosAdr" [popperShowOnStart]="false" [popperTrigger]="'click'"
                        [popperHideOnClickOutside]="true" [popperHideOnScroll]="true" [popperPlacement]="'top'"
                        [popperPositionFixed]="true">&nbsp;
                        <i class="fas fa-question-circle" style="cursor: pointer"></i>
                    </div>
                </div>
                <popper-content #popperPosAdr>
                    <div class="popper-content">
                        {{engLang ? 'Optional in segment NM1*87 files 837.': 'Opcional en el segmento NM1*87 en archivos
                        837.'}}
                    </div>
                </popper-content>

                <div *ngIf="data.lstTyp === 'prov'">
                    <mat-form-field>
                        <input matInput placeholder="{{engLang ? 'Address 1':'Dirección 1'}}" formControlName="poAd1"
                            appUppercase #poAd1Hint maxlength="30">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{poAd1Hint.value.length}} / 30
                        </mat-hint>
                    </mat-form-field>
                    <mat-error *ngIf="poAd1.invalid && poAd1.touched" class="margin-top-20">
                        <span class="error-text" *ngIf="poAd1.errors?.['pattern'] || poAd1.errors?.required">
                            {{ engLang ? 'Required, invalid' : 'Requerida, inválida' }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'prov'">
                <div class="label-div">
                    <mat-label>{{engLang ? 'Address 2 (postal):' : 'Dirección 2 (postal):'}}</mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="{{engLang ? 'Address 2':'Dirección 2'}}" formControlName="poAd2"
                            appUppercase #poAd2Hint maxlength="30">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{poAd2Hint.value.length}} / 30
                        </mat-hint>
                    </mat-form-field>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'prov'">
                <div class="label-div">
                    <mat-label>{{engLang ? 'Zip code (postal):' : 'Código zip (postal):'}}</mat-label>
                </div>
                <div>
                    <mat-form-field class="select-width">
                        <input type="text" matInput [formControl]="zipControlPos" [matAutocomplete]="zipAutoPos"
                            placeholder="Zip Code" (keyup.enter)="onSelectZipPos($event.target.value)" #zipPosHint
                            maxlength="10">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{zipPosHint.value.length}} / 9
                        </mat-hint>
                        <!-- Autocomplete Dropdown -->
                        <mat-autocomplete #zipAutoPos="matAutocomplete"
                            (optionSelected)="onSelectZipPos($event.option.value)">
                            <mat-option *ngFor="let zip of filteredZipsPos | async" [value]="zip.zipCode">
                                {{ zip.zipCode }} <span style="font-size: 8px;">{{ zip.zipCity + ', ' + zip.zipState
                                    }}</span>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-error *ngIf="zipControlPos.invalid && zipControlPos.touched" class="margin-top-20">
                        <span class="error-text">
                            {{ engLang ? '9 digits required' : '9 dígitos requisito' }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'prov'">
                <div class="label-div">
                    <mat-label>{{engLang ? 'City (postal):' : 'Ciudad (postal):'}}</mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="{{engLang ? 'City':'Ciudad'}}" formControlName="poCity"
                            appUppercase #poCityHint maxlength="20">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{poCityHint.value.length}} / 20
                        </mat-hint>
                    </mat-form-field>
                    <mat-error *ngIf="poCity.invalid && poCity.touched" class="margin-top-20">
                        <span class="error-text">
                            {{ engLang ? 'Invalid required' : 'Inválida requisito' }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'prov'">
                <div class="label-div">
                    <mat-label>{{engLang ? 'State (postal):' : 'Estado (postal):'}}</mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="{{engLang ? 'State':'Estado'}}" formControlName="poSt" appUppercase
                            #poStHint maxlength="2">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{poStHint.value.length}} / 2
                        </mat-hint>
                    </mat-form-field>
                    <mat-error *ngIf="poSt.invalid && poSt.touched" class="margin-top-20">
                        <span class="error-text">
                            {{ engLang
                            ? poSt?.errors['ckState']?.messageEn
                            : poSt?.errors['ckState']?.messageEs }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp === 'prov' || data.lstTyp === 'prod'">
                <div style="margin-top: 15px;">
                    <mat-label>{{ data.lstTyp === 'prov' ? (engLang ? 'Tax ID Type': 'Tipo de Tax ID'): 'Tax ID'
                        }}</mat-label>
                </div>
                <div style="margin-top: -10px;" *ngIf="data.lstTyp === 'prov'">
                    <mat-radio-group name="taxIdTypeNm" (change)="onTaxIdMaskChange($event)"
                        formControlName="taxIdType">
                        <div class="d-flex flex-column align-items-start" style="gap: 0;">
                            <mat-radio-button value="ssn">
                                <div matTooltipPosition="before"
                                    matTooltip="{{engLang ? 'Social Security': 'Seguro Social'}}">SSN</div>
                            </mat-radio-button>
                            <mat-radio-button value="ein">
                                <div matTooltipPosition="before"
                                    matTooltip="{{engLang ? 'Employer ID': 'Número Patronal'}}">EIN</div>
                            </mat-radio-button>
                        </div>
                    </mat-radio-group>
                </div>

                <div>
                    <mat-form-field>
                        <input matInput placeholder="Tax ID" formControlName="taxId" appUppercase
                            [mask]="data.lstTyp === 'prod' || taxIdType?.value === 'ssn' ? '000-00-0000' : '00-0000000'"
                            [placeholder]="data.lstTyp === 'prod' || taxIdType?.value === 'ssn' ? 'XXX-XX-XXXX' : 'XX-XXXXXXX'">
                    </mat-form-field>
                    <mat-error *ngIf="(taxId.errors?.['pattern'] || taxId.errors?.required) && taxId.touched"
                        class="margin-top-20">
                        <span class="error-text">
                            {{ engLang
                            ? "9 digits required"
                            : "9 dígitos requisito" }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between"
                *ngIf="data.lstTyp !=='plan' && data.lstTyp !=='fac' && data.lstTyp !=='ref'">
                <div class="label-div">
                    <mat-label>{{engLang ? 'Cel phone:' : 'Tel Celular:'}}</mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="{{engLang ? 'Cel':'Celular'}}" formControlName="phone"
                            mask="(000) 000-0000" placeholder="(000) 000-0000">
                    </mat-form-field>
                    <mat-error *ngIf="phone.invalid && phone.touched" class="margin-top-20">
                        <span class="error-text">
                            {{ engLang ? 'Invalid' : 'Inválido' }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between"
                *ngIf="data.lstTyp !=='plan' && data.lstTyp !=='fac' && data.lstTyp !=='ref'">
                <div class="label-div">
                    <mat-label>Email</mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput placeholder="Email" formControlName="email" #emailHint maxlength="50">
                        <mat-hint class="font9 margin-top-5" align="end">
                            {{emailHint.value.length}} / 50
                        </mat-hint>
                    </mat-form-field>
                    <mat-error *ngIf="email.invalid && email.touched" class="margin-top-20">
                        <span class="error-text">
                            {{ engLang ? 'Invalid' : 'Inválido' }}
                        </span>
                    </mat-error>
                </div>
            </div>

            <div class="d-flex justify-content-between" *ngIf="data.lstTyp ==='plan'">
                <div class="label-div">
                    <mat-label>Claim Filing Indicator Code (SBR09 Loop 2000B):</mat-label>
                </div>
                <div>
                    <mat-form-field>
                        <mat-select class="font15 pointr" (selectionChange)="onChange_cfi($event.value)"
                            formControlName="cfi">

                            <mat-option *ngFor="let cfi of cfis" [value]="cfi.code">
                                {{cfi.code}}<span style="font-size: 8px;">{{' (' + cfi.descr + ')'}}</span>
                            </mat-option>

                        </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="cfi.errors?.required && cfi.touched" class="margin-top-20">
                        <span class="error-text">
                            {{ engLang ? 'Required' : 'Requisito' }}
                        </span>
                    </mat-error>
                </div>
            </div>

        </mat-dialog-content>

        <div class="font9 pl-3">&nbsp;&nbsp;Esc - exit
        </div>
        <!-- <pre>{{form.valid}}</pre> -->
    </div>
</div>